import React from "react";

export function ShareIconThick(props: any) {
  return (
    <svg
      width={17}
      height={16}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.765 6.76346L11.765 9.76346C11.6939 9.8297 11.5999 9.86576 11.5027 9.86405C11.4056 9.86233 11.3129 9.82298 11.2442 9.75427C11.1755 9.68556 11.1361 9.59287 11.1344 9.49572C11.1327 9.39857 11.1688 9.30455 11.235 9.23346L13.5944 6.87346H10.8125C9.565 6.87243 8.3526 7.2864 7.36624 8.05019C6.37989 8.81397 5.67563 9.88416 5.36437 11.0922C5.33951 11.1885 5.27741 11.271 5.19173 11.3215C5.10605 11.372 5.00381 11.3864 4.9075 11.3616C4.81119 11.3367 4.72871 11.2746 4.67819 11.1889C4.62767 11.1033 4.61326 11.001 4.63812 10.9047C4.99095 9.53566 5.78911 8.32284 6.90692 7.45724C8.02474 6.59163 9.39872 6.12241 10.8125 6.12346H13.5956L11.235 3.76346C11.1688 3.69237 11.1327 3.59835 11.1344 3.5012C11.1361 3.40405 11.1755 3.31135 11.2442 3.24265C11.3129 3.17394 11.4056 3.13459 11.5027 3.13287C11.5999 3.13116 11.6939 3.16722 11.765 3.23346L14.765 6.23346C14.8352 6.30377 14.8747 6.39908 14.8747 6.49846C14.8747 6.59783 14.8352 6.69315 14.765 6.76346ZM12.5 13.1235H2.875V5.49846C2.875 5.399 2.83549 5.30362 2.76517 5.23329C2.69484 5.16297 2.59946 5.12346 2.5 5.12346C2.40054 5.12346 2.30516 5.16297 2.23483 5.23329C2.16451 5.30362 2.125 5.399 2.125 5.49846V13.4985C2.125 13.5979 2.16451 13.6933 2.23483 13.7636C2.30516 13.834 2.40054 13.8735 2.5 13.8735H12.5C12.5995 13.8735 12.6948 13.834 12.7652 13.7636C12.8355 13.6933 12.875 13.5979 12.875 13.4985C12.875 13.399 12.8355 13.3036 12.7652 13.2333C12.6948 13.163 12.5995 13.1235 12.5 13.1235Z"
        fill="#1f2937"
        stroke="#1f2937"
        strokeWidth="0.8"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
}
